export default __webpack_public_path__ + "static/media/ds-desafios-arit-js.51d81de3.png";